import { useCallback, useState } from 'react';
import type { LayoutChangeEvent, LayoutRectangle } from 'react-native';

export type LayoutEventHandler = (event: LayoutChangeEvent) => void;

export const useComponentLayout = (): [
    LayoutRectangle | undefined,
    LayoutEventHandler,
] => {
    const [layout, setLayout] = useState<LayoutRectangle>();

    const onLayout = useCallback((event: LayoutChangeEvent) => {
        const { layout } = event.nativeEvent;
        setLayout(layout);
    }, []);

    return [layout, onLayout];
};
